import { useMemo } from 'react';
var variantRegexp = /(primary)|(minor)|(alt-bg)|(text)|(secondary)/g;
export var useVariant = function useVariant(variant) {
  return useMemo(function () {
    return variant.match(variantRegexp) || [];
  }, [variant]);
};
export var useRel = function useRel(rel, target) {
  var _a;
  var prefix = target === 'blank' && !(rel === null || rel === void 0 ? void 0 : rel.includes('noopener')) ? "noopener " : '';
  return "".concat(prefix).concat((_a = rel === null || rel === void 0 ? void 0 : rel.join('  ')) !== null && _a !== void 0 ? _a : '');
};